<div class="dialog-default d-flex flex-column">
    <div class="d-flex flex-row m-2">
        <h1 class="m-0" mat-dialog-title>
            Nous avons trouvé {{duplicates.length}} jeune{{duplicates.length > 0 ? 's' : ''}}
            avec les mêmes informations
        </h1>
        <span class="flex-fill separator"></span>
        <button (click)="abortAction()"
                aria-label="Close"
                class="close"
                type="button">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <p class="my-0">Il est possible que le jeune que vous souhaitez inscrire existe déjà.</p>
    <p class="my-0">Si c'est le cas, sélectionnez le jeune concerné :</p>
    <div class="radio-group my-3 flex-fill">
        <div *ngFor="let duplicate of duplicates" class="custom-control custom-radio">
            <input
                    [(ngModel)]="result"
                    [value]="duplicate.id"
                    class="custom-control-input"
                    id="{{'radio' + duplicate.id}}"
                    type="radio">
            <label class="custom-control-label" for="{{'radio' + duplicate.id}}">{{duplicate.name}}</label>
        </div>
    </div>
    <div class="my-md-3 my-5 row align-items-center justify-content-end">
        <button (click)="exit()" class="btn btn-primary mr-5">Valider</button>
    </div>
    <div class="row align-items-center justify-content-end create-young">
        <p class="m-0">S'il n'est pas présent dans la liste : </p>
        <button (click)="createYoung()" class="mr-3" mat-button>Créer un jeune</button>
    </div>
</div>
